import { render, staticRenderFns } from "./AccessRequestForm.vue?vue&type=template&id=78f734fb&"
import script from "./AccessRequestForm.vue?vue&type=script&lang=js&"
export * from "./AccessRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports